import * as React from 'react';

import { NetworksPageLocale } from './networksPage.locale';
import Header from '../Header/Header';
import NetworksTable from '../../containers/NetworksPage/NetworksTable/NetworksTable';
import { Network } from '../../GraphQL';
import headerBg from './headerBg.svg';

interface NetworksPageProps {
  locale: NetworksPageLocale;
  networks: Network[];
}

const NetworksPage: React.SFC<NetworksPageProps> = ({ locale, networks }) => (
  <>
    <Header
      title={locale.header.title}
      subtitle={locale.header.subtitle}
      backgroundImage={headerBg}
      backgroundPosition="center -10%"
      backgroundSize="auto 170%"
    />
    <main>
      <NetworksTable locale={locale.table} networks={networks} />
    </main>
  </>
);

export default NetworksPage;



// WEBPACK FOOTER //
// /www/client/src/components/NetworksPage/NetworksPage.tsx